// import React, { useContext, useState, useEffect } from 'react';
// import { ChevronLeft, AlertCircle, CheckCircle, Loader2, Building2, Calendar, CreditCard } from 'lucide-react';
// import { useNavigate, useParams } from 'react-router-dom';
// import AuthContext from '../../../../context/AuthContext';
// import subscriptionServices from '../../../../services/subscriptionServices';

// export default function UpdateSubscription() {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const { user, authTokens } = useContext(AuthContext);

//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState('');
//   const [successMessage, setSuccessMessage] = useState('');
//   const [subscription, setSubscription] = useState(null);

//   const [formData, setFormData] = useState({
//     start_date: '',
//     end_date: '',
//     reason: ''
//   });

//   useEffect(() => {
//     if (id) {
//       fetchSubscriptionDetails();
//     }
//   }, [id]);

//   const fetchSubscriptionDetails = async () => {
//     setLoading(true);
//     setError('');
    
//     try {
//       const response = await subscriptionServices.getSubscriptionDetails(authTokens.access, { id });
      
//       if (response.success) {
//         // Handle nested response structure
//         const subscriptionData = {
//           ...response.data.subscription,
//           organization: response.data.organization
//         };
//         setSubscription(subscriptionData);
        
//         // Pre-fill form with current data
//         const sub = response.data.subscription;
//         const startDate = sub.start_date ? new Date(sub.start_date).toISOString().split('T')[0] : '';
//         const endDate = sub.end_date ? new Date(sub.end_date).toISOString().split('T')[0] : '';
        
//         setFormData({
//           start_date: startDate,
//           end_date: endDate,
//           reason: sub.reason || ''
//         });
//       } else {
//         setError(response.error || 'Erreur lors du chargement de l\'abonnement');
//       }
//     } catch (err) {
//       setError('Erreur de connexion lors du chargement');
//       console.error('Error fetching subscription details:', err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));

//     // Clear error when user makes changes
//     if (error) {
//       setError('');
//     }
//   };

//   const validateForm = () => {
//     if (!formData.start_date) {
//       setError('La date de début est requise');
//       return false;
//     }

//     if (!formData.end_date) {
//       setError('La date de fin est requise');
//       return false;
//     }

//     const startDate = new Date(formData.start_date);
//     const endDate = new Date(formData.end_date);

//     if (endDate <= startDate) {
//       setError('La date de fin doit être postérieure à la date de début');
//       return false;
//     }

//     if (!formData.reason.trim()) {
//       setError('La raison de la modification est requise');
//       return false;
//     }

//     setError('');
//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) {
//       return;
//     }

//     setSaving(true);
//     setError('');
//     setSuccessMessage('');
    
//     try {
//       const updateData = {
//         organization_id: subscription.organization.id,
//         start_date: subscriptionServices.formatDateForAPI(formData.start_date),
//         end_date: subscriptionServices.formatDateForAPI(formData.end_date),
//         reason: formData.reason.trim()
//       };

//       const response = await subscriptionServices.updateSubscription(authTokens.access, updateData);

//       if (response.success) {
//         setSuccessMessage('Abonnement modifié avec succès!');
        
//         // Redirect after success
//         setTimeout(() => {
//           navigate(`/admin-panel/subscriptions/${id}`);
//         }, 2000);
//       } else {
//         throw new Error(response.error || 'Erreur lors de la modification de l\'abonnement');
//       }
//     } catch (err) {
//       setError(err.message || 'Une erreur est survenue lors de la modification');
//       console.error('Error:', err);
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleCancel = () => {
//     navigate(`/admin-panel/subscriptions/${id}`);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     return new Date(dateString).toLocaleDateString('fr-FR', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const getStatusBadge = (status) => {
//     const statusConfig = {
//       active: { bg: 'bg-green-100', text: 'text-green-700', label: 'Actif' },
//       expired: { bg: 'bg-red-100', text: 'text-red-700', label: 'Expiré' },
//       suspended: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Suspendu' },
//       cancelled: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Annulé' }
//     };

//     const config = statusConfig[status] || statusConfig.cancelled;
//     return (
//       <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${config.bg} ${config.text}`}>
//         {config.label}
//       </span>
//     );
//   };

//   if (loading) {
//     return (
//       <div className="p-6 max-w-7xl mx-auto">
//         <div className="flex items-center justify-center py-12">
//           <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
//           <span className="ml-2 text-gray-600">Chargement de l'abonnement...</span>
//         </div>
//       </div>
//     );
//   }

//   if (error && !subscription) {
//     return (
//       <div className="p-6 max-w-7xl mx-auto">
//         <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start">
//           <AlertCircle className="h-5 w-5 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
//           <div>
//             <h3 className="text-sm font-semibold text-red-800">Erreur</h3>
//             <p className="text-sm text-red-700 mt-1">{error}</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!subscription) {
//     return (
//       <div className="p-6 max-w-7xl mx-auto">
//         <div className="text-center py-12">
//           <p className="text-gray-500">Abonnement non trouvé</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-5 sm:p-6 max-w-4xl mx-auto w-full">
//       {/* Header */}
//       <div className="flex items-center mb-6">
//         <button
//           onClick={handleCancel}
//           className="mr-3 p-1 hover:bg-gray-100 rounded transition-colors"
//         >
//           <ChevronLeft className="h-5 w-5 text-gray-600" />
//         </button>
//         <div>
//           <h1 className="text-lg font-semibold text-gray-900">Modifier l'abonnement</h1>
//           <p className="text-sm text-gray-400 mt-1">
//             Modifiez les détails de l'abonnement pour {subscription.organization?.name}
//           </p>
//         </div>
//       </div>

//       {/* Current Subscription Info */}
//       <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
//         <div className="flex items-start">
//           <Building2 className="h-5 w-5 text-blue-600 mr-3 flex-shrink-0 mt-0.5" />
//           <div className="flex-1">
//             <h3 className="text-sm font-semibold text-blue-800">Abonnement actuel</h3>
//             <div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-4 text-xs">
//               <div>
//                 <span className="text-blue-600 font-medium">Statut:</span> {getStatusBadge(subscription.status)}
//               </div>
//               <div>
//                 <span className="text-blue-600 font-medium">Début:</span> {formatDate(subscription.start_date)}
//               </div>
//               <div>
//                 <span className="text-blue-600 font-medium">Fin:</span> {formatDate(subscription.end_date)}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Error Message */}
//       {error && (
//         <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-start space-x-3">
//           <AlertCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
//           <p className="text-xs text-red-700">{error}</p>
//         </div>
//       )}

//       {/* Success Message */}
//       {successMessage && (
//         <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-start space-x-3">
//           <CheckCircle className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" />
//           <p className="text-xs text-green-700">{successMessage}</p>
//         </div>
//       )}

//       {/* Form */}
//       <form onSubmit={handleSubmit} className="space-y-6">
//         <div className="bg-white rounded-lg border border-gray-200 p-6">
//           <div className="flex items-center mb-6">
//             <CreditCard className="h-5 w-5 text-blue-600 mr-2" />
//             <h2 className="text-md font-semibold text-gray-900">Nouvelles dates d'abonnement</h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             {/* Start Date */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Nouvelle date de début *
//               </label>
//               <div className="relative">
//                 <Calendar className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
//                 <input
//                   type="date"
//                   name="start_date"
//                   value={formData.start_date}
//                   onChange={handleInputChange}
//                   className="w-full pl-10 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   disabled={saving}
//                   required
//                 />
//               </div>
//             </div>

//             {/* End Date */}
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Nouvelle date de fin *
//               </label>
//               <div className="relative">
//                 <Calendar className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
//                 <input
//                   type="date"
//                   name="end_date"
//                   value={formData.end_date}
//                   onChange={handleInputChange}
//                   className="w-full pl-10 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   disabled={saving}
//                   required
//                 />
//               </div>
//             </div>

//             {/* Reason */}
//             <div className="md:col-span-2">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Raison de la modification *
//               </label>
//               <textarea
//                 name="reason"
//                 value={formData.reason}
//                 onChange={handleInputChange}
//                 placeholder="Expliquez pourquoi vous modifiez cet abonnement..."
//                 rows={3}
//                 className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
//                 disabled={saving}
//                 required
//               />
//               <p className="text-xs text-gray-500 mt-1">
//                 Cette raison sera enregistrée dans l'historique de l'abonnement
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Form Actions */}
//         <div className="flex items-center justify-end space-x-4">
//           <button
//             type="button"
//             onClick={handleCancel}
//             className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
//             disabled={saving}
//           >
//             Annuler
//           </button>
//           <button
//             type="submit"
//             disabled={saving}
//             className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 rounded-lg transition-colors"
//           >
//             {saving && <Loader2 className="h-4 w-4 animate-spin" />}
//             <span>{saving ? 'Modification...' : 'Modifier l\'abonnement'}</span>
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }



import React, { useContext, useState, useEffect } from 'react';
import { ChevronLeft, AlertCircle, CheckCircle, Loader2, Building2, Calendar, CreditCard, Users, Plus } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import AuthContext from '../../../../context/AuthContext';
import subscriptionServices from '../../../../services/subscriptionServices';

export default function UpdateSubscription() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user, authTokens } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [subscription, setSubscription] = useState(null);

  const [formData, setFormData] = useState({
    start_date: '',
    end_date: '',
    reason: '',
    additional_users: 0
  });

  const [currentMaxUsers, setCurrentMaxUsers] = useState(0);

  useEffect(() => {
    if (id) {
      fetchSubscriptionDetails();
    }
  }, [id]);

  const fetchSubscriptionDetails = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await subscriptionServices.getSubscriptionDetails(authTokens.access, { id });
      
      if (response.success) {
        // Handle nested response structure
        const subscriptionData = {
          ...response.data.subscription,
          organization: response.data.organization
        };
        setSubscription(subscriptionData);
        
        // Set current max users
        setCurrentMaxUsers(response.data.organization.max_num_users || 0);
        
        // Pre-fill form with current data
        const sub = response.data.subscription;
        const startDate = sub.start_date ? new Date(sub.start_date).toISOString().split('T')[0] : '';
        const endDate = sub.end_date ? new Date(sub.end_date).toISOString().split('T')[0] : '';
        
        setFormData({
          start_date: startDate,
          end_date: endDate,
          reason: sub.reason || '',
          additional_users: 0
        });
      } else {
        setError(response.error || 'Erreur lors du chargement de l\'abonnement');
      }
    } catch (err) {
      setError('Erreur de connexion lors du chargement');
      console.error('Error fetching subscription details:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user makes changes
    if (error) {
      setError('');
    }
  };

  const handleAddUsers = () => {
    setFormData(prev => ({
      ...prev,
      additional_users: prev.additional_users + 10
    }));
    if (error) setError('');
  };

  const handleRemoveUsers = () => {
    setFormData(prev => ({
      ...prev,
      additional_users: Math.max(0, prev.additional_users - 10)
    }));
    if (error) setError('');
  };

  const validateForm = () => {
    if (!formData.start_date) {
      setError('La date de début est requise');
      return false;
    }

    if (!formData.end_date) {
      setError('La date de fin est requise');
      return false;
    }

    const startDate = new Date(formData.start_date);
    const endDate = new Date(formData.end_date);

    if (endDate <= startDate) {
      setError('La date de fin doit être postérieure à la date de début');
      return false;
    }

    if (!formData.reason.trim()) {
      setError('La raison de la modification est requise');
      return false;
    }

    setError('');
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setSaving(true);
    setError('');
    setSuccessMessage('');
    
    try {
      const updateData = {
        organization_id: subscription.organization.id,
        start_date: subscriptionServices.formatDateForAPI(formData.start_date),
        end_date: subscriptionServices.formatDateForAPI(formData.end_date),
        reason: formData.reason.trim(),
        additional_users: formData.additional_users
      };

      const response = await subscriptionServices.updateSubscription(authTokens.access, updateData);

      console.log(response)

      if (response.success) {
        setSuccessMessage('Abonnement modifié avec succès!');
        
        // Redirect after success
        setTimeout(() => {
          navigate(`/admin-panel/subscriptions/${id}`);
        }, 2000);
      } else {
        throw new Error(response.error || 'Erreur lors de la modification de l\'abonnement');
      }
    } catch (err) {
      setError(err.message || 'Une erreur est survenue lors de la modification');
      console.error('Error:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate(`/admin-panel/subscriptions/${id}`);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { bg: 'bg-green-100', text: 'text-green-700', label: 'Actif' },
      expired: { bg: 'bg-red-100', text: 'text-red-700', label: 'Expiré' },
      suspended: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Suspendu' },
      cancelled: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Annulé' }
    };

    const config = statusConfig[status] || statusConfig.cancelled;
    return (
      <span className={`inline-block px-2 py-1 rounded text-xs font-medium ${config.bg} ${config.text}`}>
        {config.label}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
          <span className="ml-2 text-gray-600">Chargement de l'abonnement...</span>
        </div>
      </div>
    );
  }

  if (error && !subscription) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start">
          <AlertCircle className="h-5 w-5 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
          <div>
            <h3 className="text-sm font-semibold text-red-800">Erreur</h3>
            <p className="text-sm text-red-700 mt-1">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!subscription) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="text-center py-12">
          <p className="text-gray-500">Abonnement non trouvé</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-5 sm:p-6 max-w-4xl mx-auto w-full">
      {/* Header */}
      <div className="flex items-center mb-6">
        <button
          onClick={handleCancel}
          className="mr-3 p-1 hover:bg-gray-100 rounded transition-colors"
        >
          <ChevronLeft className="h-5 w-5 text-gray-600" />
        </button>
        <div>
          <h1 className="text-lg font-semibold text-gray-900">Modifier l'abonnement</h1>
          <p className="text-sm text-gray-400 mt-1">
            Modifiez les détails de l'abonnement pour {subscription.organization?.name}
          </p>
        </div>
      </div>

      {/* Current Subscription Info */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <div className="flex items-start">
          <Building2 className="h-5 w-5 text-green-600 mr-3 flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-green-800">Abonnement actuel</h3>
            <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-xs">
              <div>
                <span className="text-green-600 font-medium">Statut:</span> {getStatusBadge(subscription.status)}
              </div>
              <div>
                <span className="text-green-600 font-medium">Début:</span> {formatDate(subscription.start_date)}
              </div>
              <div>
                <span className="text-green-600 font-medium">Fin:</span> {formatDate(subscription.end_date)}
              </div>
              <div>
                <span className="text-green-600 font-medium">Max utilisateurs:</span> {currentMaxUsers}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg flex items-start space-x-3">
          <AlertCircle className="h-4 w-4 text-red-600 mt-0.5 flex-shrink-0" />
          <p className="text-xs text-red-700">{error}</p>
        </div>
      )}

      {/* Success Message */}
      {successMessage && (
        <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg flex items-start space-x-3">
          <CheckCircle className="h-4 w-4 text-green-600 mt-0.5 flex-shrink-0" />
          <p className="text-xs text-green-700">{successMessage}</p>
        </div>
      )}

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <div className="flex items-center mb-6">
            <CreditCard className="h-5 w-5 text-green-600 mr-2" />
            <h2 className="text-md font-semibold text-gray-900">Nouvelles dates d'abonnement</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Start Date */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nouvelle date de début *
              </label>
              <div className="relative">
                <Calendar className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleInputChange}
                  className="w-full pl-10 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={saving}
                  required
                />
              </div>
            </div>

            {/* End Date */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nouvelle date de fin *
              </label>
              <div className="relative">
                <Calendar className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
                <input
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleInputChange}
                  className="w-full pl-10 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={saving}
                  required
                />
              </div>
            </div>

            {/* User Capacity */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nombre d'utilisateurs
              </label>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center space-x-2">
                    <Users className="h-5 w-5 text-gray-500" />
                    <span className="text-sm text-gray-600">Capacité actuelle:</span>
                    <span className="font-semibold text-gray-900">{currentMaxUsers}</span>
                  </div>
                </div>
                
                {formData.additional_users > 0 && (
                  <div className="flex items-center justify-between mb-3 pb-3 border-b border-gray-200">
                    <div className="flex items-center space-x-2">
                      <Plus className="h-4 w-4 text-green-600" />
                      <span className="text-sm text-gray-600">Utilisateurs à ajouter:</span>
                      <span className="font-semibold text-green-600">+{formData.additional_users}</span>
                    </div>
                  </div>
                )}

                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <span className="text-sm text-gray-600">Nouvelle capacité totale:</span>
                    <span className="text-lg font-bold text-green-600">
                      {currentMaxUsers + formData.additional_users}
                    </span>
                  </div>
                  <div className="flex items-center space-x-2">
                    {formData.additional_users > 0 && (
                      <button
                        type="button"
                        onClick={handleRemoveUsers}
                        disabled={saving}
                        className="px-3 py-1.5 text-xs font-medium text-red-600 bg-red-50 hover:bg-red-100 border border-red-200 rounded-lg transition-colors disabled:opacity-50"
                      >
                        -10
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={handleAddUsers}
                      disabled={saving}
                      className="px-3 py-1.5 text-xs font-medium text-green-600 bg-green-50 hover:bg-green-100 border border-green-200 rounded-lg transition-colors disabled:opacity-50 flex items-center space-x-1"
                    >
                      <Plus className="h-3 w-3" />
                      <span>Ajouter 10</span>
                    </button>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                Cliquez sur "Ajouter 10" pour augmenter la capacité par tranche de 10 utilisateurs
              </p>
            </div>

            {/* Reason */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Raison de la modification *
              </label>
              <textarea
                name="reason"
                value={formData.reason}
                onChange={handleInputChange}
                placeholder="Expliquez pourquoi vous modifiez cet abonnement..."
                rows={3}
                className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                disabled={saving}
                required
              />
              <p className="text-xs text-gray-500 mt-1">
                Cette raison sera enregistrée dans l'historique de l'abonnement
              </p>
            </div>
          </div>
        </div>

        {/* Form Actions */}
        <div className="flex items-center justify-end space-x-4">
          <button
            type="button"
            onClick={handleCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
            disabled={saving}
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={saving}
            className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 disabled:bg-blue-400 rounded-lg transition-colors"
          >
            {saving && <Loader2 className="h-4 w-4 animate-spin" />}
            <span>{saving ? 'Modification...' : 'Modifier l\'abonnement'}</span>
          </button>
        </div>
      </form>
    </div>
  );
}
